import { render, staticRenderFns } from "./wisdomForm.vue?vue&type=template&id=57b1e47c&scoped=true&"
import script from "./wisdomForm.vue?vue&type=script&lang=js&"
export * from "./wisdomForm.vue?vue&type=script&lang=js&"
import style0 from "./wisdomForm.vue?vue&type=style&index=0&id=57b1e47c&scoped=true&lang=css&"
import style1 from "./wisdomForm.vue?vue&type=style&index=1&lang=css&"
import style2 from "./wisdomForm.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b1e47c",
  null
  
)

export default component.exports